import { PlusCircle } from "react-bootstrap-icons";
import { AsyncButton } from "../../controls/AsyncButton";

/**
 * Props for the AddWhereClauseButton component.
 */
export interface AddWhereClauseButtonProps {
  /** Unique identifier for the button element. */
  id: string;
  /** Callback function invoked when the button is clicked. */
  onClick: () => void;
  /** Indicates whether an asynchronous operation is in progress; typically used to disable the button and show loading state. */
  isPending: boolean;
  /** Whether the button is disabled regardless of pending state. */
  disabled?: boolean;
}

/**
 * Renders the add button for adding a new clause.
 *
 * @param props - The component props
 * @param props.id - Unique identifier for the button element
 * @param props.onClick - Click handler function to add a new clause
 * @param props.isPending - Boolean indicating if the add action is currently pending (for loading state)
 * @param props.disabled - Whether the button is disabled regardless of pending state.
 * @returns Add button component
 */
export const AddWhereClauseButton = ({
  id,
  onClick,
  isPending,
  disabled = false,
}: AddWhereClauseButtonProps) => (
  <AsyncButton
    aria-label="Add clause"
    className="mt-2 d-flex align-items-center"
    disabled={isPending || disabled}
    id={id}
    onClick={onClick}
    requestStatus={isPending ? { requesting: true, error: false } : undefined}
    size="sm"
    variant="success"
  >
    <span className="me-2">Add clause</span>
    <PlusCircle />
  </AsyncButton>
);

AddWhereClauseButton.displayName = "AddWhereClauseButton";
